import Vue from 'vue'
import App from './App.vue'

// additional style libraries
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'

//internationalization tool
// import i18next from 'i18next';

// animation tool
import { gsap } from "gsap";

Vue.use(gsap);

// additional code libraries

Vue.config.productionTip = false

export const serverBus = new Vue({
  data () {
    return {
      showAdvanced: false
    }
  }
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
